import { render, staticRenderFns } from "./MagicLinkFormModal.vue?vue&type=template&id=040b5810&scoped=true&"
import script from "./MagicLinkFormModal.vue?vue&type=script&lang=js&"
export * from "./MagicLinkFormModal.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkFormModal.vue?vue&type=style&index=0&id=040b5810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b5810",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSelect: require('/workspace/components/Form/FormSelect.vue').default,FormInput: require('/workspace/components/Form/FormInput.vue').default})
